export default {
  readers: [
    'GeoReaders',
    'Admin'
  ]
}
